export default __webpack_public_path__ + "static/radler_badge_EN-5babe3240185a3b5093471be5cdc557b.svg";